import { getScrollContainer } from '@/lib/scroll-container';

/**
 * Scroll a Settings section anchor into view inside SidebarInset and
 * flash-highlight it. The console's one scroll: settings search, legacy
 * deep-links and the in-panel `SectionLink`s all use it.
 */
export function scrollToSection(sectionId: string): void {
  const doScroll = (behavior: ScrollBehavior) => {
    const target = document.getElementById(sectionId);
    if (!target) return;
    const container = getScrollContainer(target);
    if (container) {
      // Clear the sticky chrome: TopHeader (~56px) + sticky panel header
      // (~64px) + breathing room.
      const top =
        target.getBoundingClientRect().top -
        container.getBoundingClientRect().top +
        container.scrollTop -
        140;
      container.scrollTo({ top, behavior });
    }
  };
  const reduced = window.matchMedia?.('(prefers-reduced-motion: reduce)').matches ?? false;
  // Two rAF ticks let the newly mounted panel lay out first.
  requestAnimationFrame(() => {
    requestAnimationFrame(() => {
      doScroll(reduced ? 'auto' : 'smooth');
      const target = document.getElementById(sectionId);
      if (target) {
        target.classList.add('ring-2', 'ring-primary/50');
        window.setTimeout(() => target.classList.remove('ring-2', 'ring-primary/50'), 1900);
      }
      // Corrective pass: async section content above the anchor keeps
      // expanding after mount and shifts the layout — re-anchor once the
      // queries have had a moment to settle.
      window.setTimeout(() => doScroll('auto'), 650);
    });
  });
}
